module.exports = __webpack_public_path__ + "cement/img/组 25083@2x.0c589262.png";